/* Styles for the dark theme button */

import { IThemedButtonVariants } from '@belong/types';
import { COLOURS } from '../../helpers';

export const getButtonVariants = (): IThemedButtonVariants => ({
  primary: {
    backgroundColor: COLOURS.BELONG_BLUE,
    borderColor: COLOURS.BELONG_BLUE,
    color: COLOURS.BLACK,
    hover: {
      backgroundColor: 'transparent',
      borderColor: COLOURS.BELONG_BLUE_DARK,
      color: COLOURS.WHITE
    },
    active: {
      backgroundColor: COLOURS.BELONG_BLUE_DARK,
      borderColor: COLOURS.BELONG_BLUE_DARK
    },
    disabled: {
      backgroundColor: COLOURS.GREY_200,
      borderColor: COLOURS.GREY_200,
      color: COLOURS.GREY_500
    },
    selected: {
      background: 'transparent',
      border: 'none',
      hover: {
        backgroundColor: 'transparent',
        border: 'none'
      },
      active: {
        backgroundColor: 'transparent',
        border: 'none'
      }
    },
    loading: {
      backgroundColor: COLOURS.GREY_200
    }
  },
  secondary: {
    backgroundColor: 'transparent',
    borderColor: COLOURS.BELONG_BLUE,
    color: COLOURS.WHITE,
    hover: {
      backgroundColor: COLOURS.BELONG_BLUE,
      borderColor: COLOURS.BELONG_BLUE,
      color: COLOURS.BLACK
    },
    active: {
      backgroundColor: 'transparent',
      borderColor: COLOURS.BELONG_BLUE,
      color: COLOURS.WHITE
    },
    disabled: {
      backgroundColor: 'transparent',
      borderColor: COLOURS.GREY_300,
      color: COLOURS.GREY_400
    },
    selected: {
      background: 'transparent',
      border: 'none',
      hover: {
        backgroundColor: 'transparent',
        border: 'none'
      },
      active: {
        backgroundColor: 'transparent',
        border: 'none'
      }
    },
    loading: {
      backgroundColor: COLOURS.GREY_200,
      borderColor: 'transparent',
      color: COLOURS.BLACK
    },
    currentSelected: {
      background: COLOURS.LIGHT_GREEN,
      border: 'none',
      hover: {
        background: COLOURS.LIGHT_GREEN,
        border: 'none'
      },
      active: {
        background: COLOURS.LIGHT_GREEN,
        border: 'none'
      }
    }
  },
  tertiary: {
    color: COLOURS.WHITE,
    borderColor: COLOURS.BELONG_BLUE_LIGHT,
    hover: {
      color: COLOURS.BELONG_BLUE_DARK,
      borderColor: COLOURS.BELONG_BLUE_DARK
    },
    active: {
      color: COLOURS.WHITE,
      borderColor: COLOURS.BELONG_BLUE_LIGHT
    },
    focus: {
      color: COLOURS.WHITE,
      borderColor: COLOURS.BELONG_BLUE_LIGHT
    },
    disabled: {
      color: COLOURS.GREY_400,
      borderColor: COLOURS.GREY_300
    }
  },
  quaternary: {
    color: COLOURS.BELONG_BLUE_LIGHT,
    focus: {
      color: COLOURS.WHITE
    },
    disabled: {
      color: COLOURS.GREY_400
    }
  }
});
